import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { FaCheck, FaCalendarAlt, FaHome } from 'react-icons/fa';
import painxy from '../assets/images/painorange.png';
import checkIcon from '../assets/images/check_circle.png';
import '../css/AppointmentConfirmation.css';
import DoctorAssignedCard from '../components/SessionDetail/DoctorAssignedCard';
import WhatHappensNext from '../components/WhatHappensNext';

const AppointmentConfirmation = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Data received in AppointmentConfirmation:", state);
  }, [state]);

  if (!state || !state.bookingData) {
    console.error("No booking data received.");
    return <p>Booking details not available</p>;
  }
  const userDetail = sessionStorage.getItem("user");
  const user = JSON.parse(userDetail);
  console.log(user);
  const painCondition = user?.pain_condition || "N/A";

  const { booking_id, user_name, therapist_name, profileImage, user_phone, user_address, start_at, end_at, current_payment } = state.bookingData;

  // Format the date & time from `start_at`
  const appointmentDate = new Date(start_at).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const appointmentTime = new Date(start_at).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <div
      className="container"
      style={{
        backgroundImage: `url(${require("../assets/images/BackgroundBig.png")})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="header-container">
        <img src={checkIcon} alt="Confirmed" className="tick-icon" />
        <span className="header-text">Appointment Confirmed!</span>
      </div>

      <div className="content-container">
        <h3 className="session-title">Physiotherapy Session with Dr. {therapist_name}</h3>

        <div className="details-row">
          <div className="detail-column">
            <span className="detail-label">Name</span>
            <span className="detail-value">{user_name}</span>
          </div>
          <div className="detail-column-right">
            <span className="detail-label">Mobile</span>
            <span className="detail-value">{user_phone}</span>
          </div>
        </div>

        <div className="details-row">
          <div className="detail-column">
            <span className="detail-label">Pin Code</span>
            <span className="detail-value">{user.pinCode}</span>
          </div>
          <div className="detail-column-right">
            <span className="detail-label">Fees</span>
            <span className="detail-value">₹{current_payment}</span>
          </div>
        </div>

        <div className="w-full mt-8 mb-8 mr-20">
          <DoctorAssignedCard
            doctorName={therapist_name}
            doctorImage={profileImage}
            className="w-full" />
        </div>





        <div className="section">
          <div className="section-row">
            <img src={require("../assets/images/calendar.png")} alt="calendar" className="section-icon" />
            <div>
              <div className="section-label">Date & Time</div>
              <div className="section-value">{appointmentDate} | {appointmentTime}</div>
            </div>
          </div>
        </div>

        {/* Address Section */}
        <div className="section">
          <div className="section-row">
            <img src={require("../assets/images/location.png")} alt="location" className="section-icon" />
            <div>
              <div className="section-label">Complete Address</div>
              <div className="section-value">{user_address}</div>
            </div>
          </div>
        </div>
        {/* <div className="icon-detail-row">
          <div className="icon-label-wrapper">
            <img src={painxy} alt="Pain Icon" style={{ width: 28, height: 28 }} className="icon" />

            <span className="detail-label">Pain Condition</span>
          </div>
          <span className="detail-value1">{painCondition}</span>
        </div> */}

        <hr className="divider" />


        <div className="message-container">
          <p className="message-text">
            An appointment confirmation has been sent to your WhatsApp. If
            you have not received it yet, please contact us +918104974290
          </p>
        </div>

        <div className="appointment-id-container">
          <span className="appointment-id-label">Appointment ID</span>
          <span className="appointment-id-value">{booking_id}</span>
        </div>

        <WhatHappensNext />

        <button className="back-button" onClick={() => navigate("/")}>
          Back To Home
        </button>
      </div>
    </div>
  );
};

export default AppointmentConfirmation;
